import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
//import Loading from '../views/Loading.vue'
import Logout from '../views/Logout.vue'
import Hello from '../views/Hello.vue'
import Register from '../views/Register.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
//import LoginSuccess from '../components/LoginSuccess.vue'

import ContactUs from '../views/ContactUs.vue'
import MyProfile from '../views/MyProfile.vue'

import Rewards from '../views/Rewards.vue'
import SendToAll from '../views/SendToAll.vue'

//import GetToKnow from '../views/GetToKnow.vue'

import ReportRecommendations from '../views/ReportRecommendations.vue'
import Statement from '../views/Statement.vue'
import Orders from '../views/Orders.vue'

import ContentPage from '../views/ContentPage.vue'



//import store from '../store/store'

Vue.use(VueRouter)

const routes = [
    { path: '/', name: 'Home', component: Home },
    { path: "/welcometrfauth", name: "WelcomeTrfAuth", component: () => import("../views/WelcomeTrfAuth.vue"), meta: { allowAnonymous: true } }, //Used to setup the session from SSO login

   // { path: '/loginsuccess', name: 'LoginSuccess', component: LoginSuccess, meta: { allowAnonymous: true } },
    //{ path: '/ssoaccess/authenticating', name: 'ssoAuthProcessing', component: AuthSSO, meta: { allowAnonymous: true } },
    //{ path: '/ssoaccess/:siteCode/:ssoKey', name: 'ssoAuth', component: AuthSSO, meta: { allowAnonymous: true } },
    { path: '/logout', name: 'Logout', component: Logout, meta: { allowAnonymous: true } },
    { path: '/hello', name: 'Hello', component: Hello, meta: { allowAnonymous: true } },
    { path: '/register', name: 'Register', component: Register, meta: { allowAnonymous: true } },
    { path: '/forgotpassword', name: 'ForgotPassword', component: ForgotPassword, meta: { allowAnonymous: true } },
    //{ path: '/loading', name: 'Loading', component: Loading, meta: { allowAnonymous: true } }

    { path: '/contactus', name: 'ContactUs', component: ContactUs, meta: { allowAnonymous: true } },
    { path: '/myprofile', name: 'MyProfile', component: MyProfile, meta: { allowAnonymous: false } },
    { path: '/myprofile/:urlParam', name: 'MyProfileUpdate', component: MyProfile, props: true, meta: { allowAnonymous: false } },

    //{
    //    path: '/about', name: 'About',
    //    // route level code-splitting
    //    // this generates a separate chunk (about.[hash].js) for this route
    //    // which is lazy-loaded when the route is visited.
    //    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    //},



    { path: '/rewards/:urlParam', component: Rewards, props: true, meta: { allowAnonymous: false } },
    { path: '/rewards', component: Rewards, meta: { allowAnonymous: false } },

    { path: '/orders', component: Orders, meta: { allowAnonymous: false } },
    //{ path: '/rewards', redirect: '/rewards/' },

    { path: '/sendtoall', name: 'SendToAll', component: SendToAll, meta: { allowAnonymous: false } },
    
    
    { path: '/gettoknow', name: 'GetToKnow', component: () => import('../views/GetToKnow.vue'), meta: { allowAnonymous: false } },
    { path: '/gettoknow/:selectedMemberId', name: 'GetToKnow2', component: () => import('../views/GetToKnow.vue'), meta: { allowAnonymous: false } },

    { path: '/reportrecommendations', name: 'ReportRecommendations', component: ReportRecommendations, meta: { allowAnonymous: false } },
    { path: '/statement', name: 'Statement', component: Statement, meta: { allowAnonymous: false } },

    { path: '/reportdashboard', name: 'ReportDashboard', component: () => import('../views/ReportDashboard.vue'), meta: { allowAnonymous: false } },


    { path: '/:contentKey', name: 'ContentPage', component: ContentPage, props: true, meta: { allowAnonymous: true } },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

//Router Guards
router.beforeEach((to, from, next) => {
    let isAllowAnonymous = to.matched.some(m => m.meta.allowAnonymous);
    if (isAllowAnonymous) {
        next();
        return;
    }

    //let isLoggedIn = !store.state.isLoggedIn;
    let bearerToken = sessionStorage.getItem('SecBr');
    if (!bearerToken) {
        //console.log('routerguard: request navigation to: ' + to.name + ', not logged in - redirect to Login');
        next({ name: 'Hello' }); //Redirect to login
    } else {
        next()
    }
    // if (to.name !== 'Login') 

})

export default router
